module.exports = __webpack_public_path__ + "img/zero.f96d4e7c.png";